
        import * as module0 from './controllers/carousel_controller.js';import * as module1 from './controllers/example_controller.js';import * as module2 from './controllers/modal_controller.js';import * as module3 from './controllers/scroll_controller.js'
        const modules = {
            "./controllers/carousel_controller.js": module0,
            "./controllers/example_controller.js": module1,
            "./controllers/modal_controller.js": module2,
            "./controllers/scroll_controller.js": module3,
        };
        export default modules;
      